import { normalizeColor } from "grommet/utils";
import * as React from "react";
import styled from "styled-components";
import Theme from "../utils/Theme";
import { useDarkMode } from "./DarkModeSwitch";

const MenuItemContainer = styled.default.div`
    background-color: ${({ darkMode }) => normalizeColor("background-back", Theme, darkMode)};
    border-radius: 15px;
    transition: background-color 0.3s ease;
    padding: 1rem;
    margin: 1rem;

    &.active:hover {
        background-color: ${({ darkMode }) => normalizeColor("background-front", Theme, darkMode)};
        cursor: pointer;
    }
`;

const MenuItemImageBlock = styled.default.div`
    position: relative;
    display: block;
    width: 160px;
    margin: auto;
    // filter: invert(${({ darkMode }) => (darkMode ? 0 : 1)});
`;

const MenuItemImage = styled.default.img`
    max-width: 160px;
    max-height: 160px;
    display: block;
`;

const MenuItemName = styled.default.div`
    white-space: nowrap;
    overflow: hidden;
    text-align: center;
    text-overflow: ellipsis;
`;

const MenuItemDescription = styled.default.div`
    text-align: center;
    color: ${(props) => props.color};
    font-size: 0.7rem;
`;

interface MenuItemProps {
    name: string;
    description: React.ReactNode;
    image?: string;
    subtext?: React.ReactNode;
    active?: boolean;
    action: () => void;
}

const MenuItem = ({ name, description, image, subtext = "", active = true, action }: MenuItemProps) => {
    const [isDarkMode] = useDarkMode();

    return (
        <MenuItemContainer darkMode={isDarkMode} className={active && "active"} onClick={() => active && action()}>
            <MenuItemImageBlock darkMode={isDarkMode}>
                <MenuItemImage src={image} alt="" />
            </MenuItemImageBlock>
            <MenuItemName>{name}</MenuItemName>
            <MenuItemDescription>{description}</MenuItemDescription>
            {subtext && <MenuItemDescription>{subtext}</MenuItemDescription>}
        </MenuItemContainer>
    );
};

export default MenuItem;
